/** @jsxImportSource @emotion/react */
import React from "react";
import {useHistory} from "react-router-dom";

const NavItem = (props) => {
    const {text = "", isActive, to = ""} = props;
    const history = useHistory();

    return (
        <div
            css={{
                color: "white",
                padding: "18px 36px",
                fontSize: 18,
                fontWeight: 100,
                borderTop: "5px solid transparent",
                borderBottom: "5px solid transparent",
                transition: "border 0.4s",
                whiteSpace: "nowrap",
                "&:hover": {
                    fontWeight: "bold",
                    cursor: "pointer",
                    borderBottomColor: "white"
                },
                "&::before": {
                    fontWeight: "bold",
                    cursor: "pointer",
                    display: "block",
                    content: "attr(title)",
                    height: 0,
                    overflow: "hidden",
                    visibility: "hidden"
                },
                ...isActive && {
                    fontWeight: "bold",
                    cursor: "pointer",
                    borderBottomColor: "white"
                }
            }}
            title={text}
            onClick={() => !!to && history.push(to)}
        >
            {text}
        </div>
    );
};

export default NavItem;